import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Footer from "../Footer";
import NavBar from "../NavBar";
import "./Layout.css";

const useStyles = makeStyles((theme) => ({
  containerMd: {
    "&.MuiContainer-maxWidthMd": {
      maxWidth: 1000,
    },
  },
}));

const Layout = ({ children }) => {
  const classes = useStyles();
  return (
    <div className="PageLayout">
      <div>
        <NavBar/>
        <Container
          maxWidth="md"
          className={`${classes.root} ${classes.containerMd}`}
        >
          <div className="MainContent">{children}</div>
        </Container>
      </div>
      <Footer  />
    </div>
  );
};
export default Layout;
